import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.last-index-of.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { importBatch } from '@/api/PMS/longTermReservation/longReservationImport';
export default {
  props: ['showDialog'],
  data: function data() {
    return {
      files: [],
      fileList: [],
      status: '',
      templateId: '',
      customColor: '#36bfa3',
      isShowProgress: false,
      percentage: 0,
      uploadUrl: '',
      childData: {},
      disBtn: false
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.files = [];
        this.fileList = [];
      }
    }
  },
  created: function created() {
    this.uploadUrl = process.env.VUE_APP_UPLOAD; // this.init()
  },
  methods: {
    submitUpload: function submitUpload() {
      var _this = this;

      this.disBtn = true;

      if (this.fileList.length === 0) {
        this.disBtn = false;
        this.Alert({
          alertType: 'error',
          message: '文件不能为空，请上传文件！'
        });
        return;
      }

      this.isShowProgress = true;
      this.percentage = 0;
      var query = {
        fileId: this.fileList[0].fileId
      };
      importBatch(query).then(function (res) {
        _this.percentage = 100;
        setTimeout(function () {
          _this.isShowProgress = false;
          _this.status = 'success';
        }, 500);

        if (res.data && res.data.code === 200) {
          _this.$emit('handCancle', true);

          _this.$message({
            message: '导入成功',
            type: 'success',
            duration: 3000
          });
        }

        _this.disBtn = false;
      }).catch(function (err) {
        _this.percentage = 100;
        setTimeout(function () {
          _this.isShowProgress = false;
          _this.status = 'success';

          _this.$emit('handCancle', true);
        }, 500);

        if (err !== 'error') {
          _this.$message({
            message: err.message,
            type: 'error',
            duration: 3000
          });
        }

        _this.disBtn = false;
      });
    },
    // 移除excel文件
    handleRemove: function handleRemove(file, fileList) {
      var _this2 = this;

      var currentUrl = 0; // 获取当前删除文件的url

      if (file.response !== undefined) {
        // 文件是新增加的
        currentUrl = file.response.data[0].fileId;
      } else {
        // 文件是旧数据
        currentUrl = file.url;
      }

      this.fileList.forEach(function (item, index) {
        if (currentUrl === item.url) {
          _this2.fileList.splice(index, 1);

          return;
        }
      });
      this.files.forEach(function (col, n) {
        if (currentUrl === col.url) {
          _this2.fileList = []; // 因为此处限制了只能上传一个文件，所以可以直接清空

          return;
        }
      });
    },
    // 下载模板
    handleDownload: function handleDownload() {
      var oa = document.createElement('a');
      oa.href = '/web/static/excel/whgcqdc.xls';
      oa.download = '长期订场导入模板';
      var event = document.createEvent('MouseEvents');
      event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, 0, null);
      oa.dispatchEvent(event);
    },
    // 上传文件时判断文件类型
    beforeUpload: function beforeUpload(file) {
      var extension = file.name.substring(file.name.lastIndexOf('.') + 1);
      extension = extension.toLowerCase();
      var fileFormatOK = extension === 'xls' || extension === 'xlsx';

      if (!fileFormatOK) {
        this.$message({
          message: '只支持上传 excel 格式文件!',
          type: 'error'
        });
        return false;
      }
    },
    handleExceed: function handleExceed(files, fileList) {
      this.$message.warning("\u6BCF\u6B21\u6700\u591A\u53EA\u80FD\u5BFC\u5165\u4E00\u4E2A\u6587\u4EF6");
    },
    // 上传excel成功时获取服务器图片URL
    handleSuccess: function handleSuccess(response, file) {
      this.fileList.push({
        url: response.data[0].fileId,
        fileId: response.data[0].fileId,
        fileName: response.data[0].fileName,
        fileType: 1
      }); // this.fileList.push({ url: file.response.data[0].fileId, fileName: response.data[0].fileName, fileType: 1 })
    },
    handleError: function handleError(err, file, fileList) {
      var res = JSON.parse(err.message);
      this.$message({
        message: res.message,
        type: 'error'
      });
    },
    // 移除excel之前做的操作
    beforeRemove: function beforeRemove(file, fileList) {// return this.$confirm(`确定移除 ${ file.name }？`)
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', true);
    }
  }
};